import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { SuccessButton } from 'components/button';
import styled from 'styled-components';
import { COLOR } from 'constants/colors';
import { useMediaQuery } from 'react-responsive';
import { addAgentCode, redirectToHome } from '__utils/common-utils';
import { CommonStyledComponentProps } from '__utils/type';
import { LayoutContext } from 'components/app-routes';
import { Row, Col } from 'antd';
import { useHistory } from 'react-router-dom';
import OrderFailedIcon from '../../images/order-failed-icon.svg';
import { propsToJS } from '__utils/immutable-to-js';
import UserSelector from 'views/user/user.selector';

import PaymentDetails from './payment-details';
import CalculatorSlider from 'components/calculator-slider';

const OuterContainer = styled.div<CommonStyledComponentProps>`
    .total-invest {
        display: flex;
        justify-content: space-between;
        margin: 16px;
    }
    .order-summary {
        padding: ${(props) => props.isMobile ? '16px' : '20px 20px 0'};
        background: white;
        fill: ${COLOR.WHITE};
        filter: drop-shadow(0px 1px 4px rgba(0, 0, 0, 0.25));
        margin-bottom: ${(props) => props.isMobile ? '16px' : '40px'};
        border-radius: 8px;
    }
    .disclaimer {
        font-size: 12px;
        margin: 20px 0;
        padding: 9px 10px;
        background: #FDEFCE;
        border-left: 6px solid ${COLOR.WARNING_DARK};
    }
    .title-sec, .desc-sec {
        display: flex;
        justify-content: space-between;
    }
    .title-sec{
        color: ${COLOR.GREY3};
        line-height: normal;
        padding-bottom: 16px;
    }
    .desc-sec {
        padding-top: 16px;
        margin-bottom: 20px;
    }
    .desc-sec h3 {
        font-size: ${(props) => props.isMobile ? '14px' : ''};
        font-weight: 500;
        line-height: normal;
    }
    .title-sec + .desc-sec, .desc-sec + .desc-sec {
        border-top: 1px solid ${COLOR.DISABLED_BTN};
    }
    .trans-failed p {
        text-transform: uppercase;
    }
`
const DesktopBtn = styled(SuccessButton)`
    margin: 30px 0;
    display: block;
    text-align: center;
    height: 40px;
    border-radius: 4px;

`;

const SliderContainer = styled.div<CommonStyledComponentProps>`
    .calculator-sec {
        display: grid;
        margin: 60px auto 44px;
        grid-row-gap: 24px;
        background: transparent;
    }
    .calculator-top h3 {
        color: ${COLOR.BLACK};
        font-size: ${(props) => props.isMobile ? '16px' : '20px'};
        font-weight: 500;
        line-height: ${(props) => props.isMobile ? '24px' : '28px'};
    }
`

const PaymentFailure: React.FC = () => {
    const history = useHistory();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { layoutProps, SetLayoutProps } = React.useContext(LayoutContext);
    const { paymentUrl } = propsToJS(useSelector(UserSelector));
    const [orderSummaryValue, setOrderSummaryValue] = useState<any>();

    useEffect(() => {
        SetLayoutProps({
            config: {
                goBackCallback: () => redirectToHome(),
                title: `Payment Error`,
            },
            showBseInfoForDesktop: false,
            showCopyrightInfoForDesktop: true,
            breadcrumbList: [ { text: 'Home', url: addAgentCode('v1/home'), isExternal: true }, { text: 'Investment Cart', url: '/cart-review', isExternal: true }, { text: 'Payment Error', url: '', isExternal: false } ],
        });
    }, []);

    const countTotalInvestment = (data: any)=>{
        setOrderSummaryValue(data);
    }

    const totalInvestmentHandler = () => {
        let totalInvestment = 0;
        orderSummaryValue?.data?.forEach((order: any) =>{
          totalInvestment += +parseFloat(order?.amount).toFixed(2);
        });
        return totalInvestment;
    }

    const checkInvestmentType = orderSummaryValue?.data?.filter((ele:any) => ele?.investmentType?.toUpperCase() == 'SIP');

    return (
        <div>
            <OuterContainer isMobile={isMobile}>
                {isMobile && <h2 className='total-invest'>Total Investment <span>₹ {totalInvestmentHandler()}</span></h2>}
                <div className='order-summary'>
                    <Row align="middle">
                        <Col className='order-placed-sec' md={2}>
                            <img src={OrderFailedIcon} />
                        </Col>
                        <Col className='order-placed-sec' md={17}>
                            <h3>Your payment attempt has failed.</h3>
                            <p>We apologise for any inconvenience caused. Any amount, if debited, will be refunded to your bank account.</p>
                        </Col>
                        <Col md={5}>
                            <div>
                                { !isMobile && <DesktopBtn onClick={ () => history.push(`/order-summary?paymentUrl=${paymentUrl}`) }>Retry Payment</DesktopBtn> }
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24}>
                            {checkInvestmentType?.length > 0 ? <p className='disclaimer'>Your SIP orders will be seen in portfolio after 2 days post installment date.</p> : <br />} 
                        </Col>
                    </Row>
                    <PaymentDetails pageType="failure" onGetOrderSuccess={countTotalInvestment}/>
                </div>
                {isMobile && <div className="footer">
                    <SuccessButton onClick={ () => history.push(`/order-summary?paymentUrl=${paymentUrl}`) }>Retry Payment</SuccessButton>
                </div>}
            </OuterContainer>
            <SliderContainer isMobile={isMobile}>
                <div className={`calculator-sec ${isMobile ? 'mt30 p16' : ''}`}>
                    <div className={`calculator-top ${isMobile ? 'calc-mobile' : 'calc-desktop'}`}>
                        <h3>Explore our financial calculators</h3>
                    </div>
                    <CalculatorSlider />
                </div>
            </SliderContainer>
        </div>
        )};

export default PaymentFailure;